var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCl = function SvgIconCl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 12c0 6.628-5.373 12-12 12S0 18.628 0 12c0-6.627 12 0 12 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M0 12C0 5.373 5.373 0 12 0v12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m7.143 4.173.777 2.392h2.515L8.4 8.043l.777 2.391-2.034-1.478-2.034 1.478.777-2.391-2.034-1.478h2.514z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconCl;